import React, { useState, useEffect } from "react";
import { ModuleCard } from "../../../../components/monitoring/ModuleCard";
import { useLocation } from "react-router-dom";

const ModuleList = () => {
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterPlatform, setFilterPlatform] = useState("all");

  // Parse URL parameters on component mount and when location changes
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const platformParam = params.get("platform");
    if (platformParam) {
      setFilterPlatform(platformParam);
    }

    const statusParam = params.get("status");
    if (statusParam) {
      setFilterStatus(statusParam);
    }
  }, [location]);

  const modules = [
    {
      id: "module-1",
      name: "SACP Module 1",
      platform: "Platform A",
      leg: "North-East",
      location: "Pillar A",
      status: "active",
      lastReading: {
        channel1: -0.85,
        channel2: -0.82,
        channel3: -0.87,
        channel4: -0.79,
      },
    },
    {
      id: "module-2",
      name: "SACP Module 2",
      platform: "Platform A",
      leg: "North-West",
      location: "Pillar B",
      status: "warning",
      lastReading: {
        channel1: -0.79,
        channel2: -0.81,
        channel3: -0.76,
        channel4: -0.82,
      },
    },
    {
      id: "module-3",
      name: "SACP Module 3",
      platform: "Platform A",
      leg: "South-East",
      location: "Pillar C",
      status: "error",
      lastReading: {
        channel1: -0.49,
        channel2: -0.28,
        channel3: -0.39,
        channel4: -0.42,
      },
    },
    {
      id: "module-4",
      name: "SACP Module 4",
      platform: "Platform A",
      leg: "South-West",
      location: "Pillar D",
      status: "error",
      lastReading: {
        channel1: -1.22,
        channel2: -1.42,
        channel3: -1.35,
        channel4: -1.21,
      },
    },
    {
      id: "module-5",
      name: "SACP Module 5",
      platform: "Platform B",
      leg: "North-East",
      location: "Pillar A",
      status: "active",
      lastReading: {
        channel1: -0.82,
        channel2: -0.8,
        channel3: -0.83,
        channel4: -0.82,
      },
    },
    {
      id: "module-6",
      name: "SACP Module 6",
      platform: "Platform B",
      leg: "North-West",
      location: "Pillar B",
      status: "active",
      lastReading: {
        channel1: -0.84,
        channel2: -0.79,
        channel3: -0.81,
        channel4: -0.83,
      },
    },
    {
      id: "module-7",
      name: "SACP Module 7",
      platform: "Platform B",
      leg: "South-East",
      location: "Pillar C",
      status: "warning",
      lastReading: {
        channel1: -0.77,
        channel2: -0.75,
        channel3: -0.74,
        channel4: -0.72,
      },
    },
    {
      id: "module-8",
      name: "SACP Module 8",
      platform: "Platform B",
      leg: "South-West",
      location: "Pillar D",
      status: "active",
      lastReading: {
        channel1: -0.83,
        channel2: -0.82,
        channel3: -0.8,
        channel4: -0.7,
      },
    },
  ];

  // Get unique platforms for filter
  const platforms = [
    "all",
    ...new Set(modules.map((module) => module.platform)),
  ];

  const filteredModules = modules.filter((module) => {
    const matchesSearch =
      module.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      module.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus =
      filterStatus === "all" || module.status === filterStatus;
    const matchesPlatform =
      filterPlatform === "all" || module.platform === filterPlatform;
    return matchesSearch && matchesStatus && matchesPlatform;
  });

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold">SACP Monitoring System Overview</h1>
      </div>

      <div className="flex flex-wrap gap-4">
        <div className="flex-1 min-w-[240px]">
          <input
            type="text"
            placeholder="Search modules..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <select
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
          className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="warning">Warning</option>
          <option value="error">Error</option>
        </select>
        <select
          value={filterPlatform}
          onChange={(e) => setFilterPlatform(e.target.value)}
          className="px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {platforms.map((platform) => (
            <option key={platform} value={platform}>
              {platform === "all" ? "All Platforms" : platform}
            </option>
          ))}
        </select>
      </div>

      {/* Platform Summary Cards */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {platforms
          .filter((p) => p !== "all")
          .map((platform) => {
            const platformModules = modules.filter(
              (m) => m.platform === platform
            );
            const active = platformModules.filter(
              (m) => m.status === "active"
            ).length;
            const warning = platformModules.filter(
              (m) => m.status === "warning"
            ).length;
            const error = platformModules.filter(
              (m) => m.status === "error"
            ).length;

            return (
              <div key={platform} className="bg-white rounded-lg shadow-md p-6">
                <h2 className="text-xl font-semibold mb-4">
                  {platform} Overview
                </h2>
                <div className="flex gap-4">
                  <div className="flex-1 text-center">
                    <div className="text-3xl font-bold text-green-500">
                      {active}
                    </div>
                    <div className="text-sm text-gray-500">Active</div>
                  </div>
                  <div className="flex-1 text-center">
                    <div className="text-3xl font-bold text-yellow-500">
                      {warning}
                    </div>
                    <div className="text-sm text-gray-500">Warning</div>
                  </div>
                  <div className="flex-1 text-center">
                    <div className="text-3xl font-bold text-red-500">
                      {error}
                    </div>
                    <div className="text-sm text-gray-500">Error</div>
                  </div>
                </div>
              </div>
            );
          })}
      </div> */}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredModules.map((module) => (
          <ModuleCard
            key={module.id}
            moduleId={module.id}
            moduleName={module.name}
            platform={module.platform}
            leg={module.leg}
            location={module.location}
            lastReading={module.lastReading}
            status={module.status}
          />
        ))}
      </div>
    </div>
  );
};

export default ModuleList;
